import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  Group,
  SegmentedControl,
  Text,
  Anchor,
  TextInput,
  Stack,
  ThemeIcon,
} from '@mantine/core';
import { IconCheck, IconExclamationMark } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { PaginatedList } from '@components/shared';
import entityIcon from '@util/entityIcon';

import { formatArtistList } from '@components/Curation/helpers';

export default function SongList({
  artistId,
  locationId,
  requestInfo = {
    url: `/retrieve-songs/`,
    data: {},
  },
  refresh,
}) {
  const { t } = useTranslation();
  // if we get a location id here, we are getting back
  // location song joins
  const [searchValue, setSearchValue] = useState('');
  const [filters, setFilters] = useState({
    curated: 'true',
  });

  const reqData = {
    ...requestInfo.data,
    search_value: searchValue,
    refresh,
    status: 1,
    curated: filters.curated === 'true' ? true : false,
  };

  if (artistId) reqData.artist_id = artistId;
  if (locationId) reqData.location_id = locationId;

  return (
    <div>
      {requestInfo && (
        <>
          <TextInput
            placeholder={t('common:search') + '...'}
            size="lg"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          {!artistId && (
            <SegmentedControl
              value={filters.curated}
              mt="xs"
              data={[
                { label: 'Curated', value: 'true' },
                { label: 'Uncurated', value: 'false' },
              ]}
              onChange={(e) => setFilters({ ...filters, curated: e })}
            />
          )}
        </>
      )}
      <PaginatedList
        requestInfo={{
          url: locationId ? `/retrieve-location-songs/` : requestInfo.url,
          data: reqData,
        }}
        responseMapping={(r) =>
          r.map((m) => ({
            ...m,
            link_url: locationId
              ? `/location-songs/${m.location_song_id}`
              : m.is_curated
              ? `/songs/${m.id}`
              : `/curation-song/${m.id}`,
          }))
        }
        displayFormatter={(item) => (
          <Card key={item.original.song_id}>
            <Group align="center" gap="sm">
              <div>
                <Anchor
                  c="dark"
                  fw={700}
                  component={Link}
                  to={item.original.link_url}
                >
                  {item.original.name || '????'}
                </Anchor>
              </div>
              {item.original.is_curated && (
                <IconCheck
                  size={16}
                  stroke={5}
                  color="var(--mantine-color-green-6)"
                  title="Curated"
                />
              )}
            </Group>
            {item.original.artists && (
              <Stack gap={5}>
                {item.original.artists.map((artist, i) => (
                  <Group gap="xs" align="center" key={i}>
                    {entityIcon.artist()}
                    <Text
                      component={Link}
                      to={`/artists/${artist.id}`}
                      size="sm"
                    >
                      {artist.name}
                    </Text>
                    {!artist.is_curated && (
                      <ThemeIcon
                        color="red"
                        size="xs"
                        radius="xl"
                        variant="light"
                        title="Uncurated"
                      >
                        <IconExclamationMark size={14} />
                      </ThemeIcon>
                    )}
                  </Group>
                ))}
              </Stack>
            )}
            {item.original.artist && (
              <Group gap="xs" align="center">
                {entityIcon.artist()}
                <Text size="sm">
                  {formatArtistList([{ ...item.original.artist }])}
                </Text>
              </Group>
            )}
          </Card>
        )}
      />
    </div>
  );
}
